import axios from 'axios'
import {ApiResponse} from '../models/Base'
import {IUpdatePassword, UserDto, UserProfileDto, UserProfileFilterDto, UserProfileRequestDto } from '../models/dto/UserProfile'
import { TableDto } from '../models/dto/SelfAssessment'
const API_URL = process.env.REACT_APP_API_URL
const USER_PROFILE_URL = `${API_URL}/user-profiles`


export function GetById(id: string) {
    return axios.get<ApiResponse<UserProfileDto>>(`${USER_PROFILE_URL}/${id}`)
}

export function Create(payload: UserProfileRequestDto) {
    return axios.post(`${USER_PROFILE_URL}`, payload)
}

export function Update(id: string, payload: UserProfileRequestDto) {
    return axios.put(`${USER_PROFILE_URL}/${id}`, payload)
}

export function  GetBroad() {
    return axios.get<ApiResponse<TableDto>>(`${USER_PROFILE_URL}/boards`)
}

export function Gets() {
    return axios.get<ApiResponse<UserProfileDto[]>>(`${USER_PROFILE_URL}`)
}
export function ChangePassword(id: string, payload: IUpdatePassword) {
    return axios.put(`${USER_PROFILE_URL}/${id}/changes/password`, payload)
}

export function CraeteUser(userProfileId: string, payload: UserDto) {
    return axios.post(`${USER_PROFILE_URL}/${userProfileId}/users`, payload)
}

export function Delete(id: number) {
    return axios.delete(`${USER_PROFILE_URL}/${id}`)
}
 
export function Search(payload: UserProfileFilterDto) {
    return axios.post<ApiResponse<UserProfileDto[]>>(`${USER_PROFILE_URL}/search`, payload)
}


export function GetUserName(userId: string) {
    return axios.get<ApiResponse<string>>(`${USER_PROFILE_URL}/user-name/${userId}`)
}
